import React from 'react'
import {Modal} from 'react-bootstrap'
import ResetPasswordForm from '../form/ResetPasswordForm'

const ResetPasswordModal = ({Builds, show, onClose, userName}: any) => {
  if (!show) {
    return null
  }

  return (
    <Modal
      className='modal fade'
      id='kt_modal_trigger_build'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      dialogClassName='modal-l'
      aria-hidden='true'
      onHide={onClose}
    >
      <div className='modal-content'>
        <ResetPasswordForm onClose={onClose} userName={userName} />
      </div>
    </Modal>
  )
}

export default ResetPasswordModal
